import api from "@/api/api";
import {ApiResponse} from "@/types/api.type";
import {
    BalanceData,
    dataTransaction,
    CreditDataMain,
    BusinessesDatum,
    PaymentData,
    ListTicketUserData,
    MapgisheDaum,
    UserBankAccountsDaum,
    WithdrawData, setProvidersPayloadType, getProvidersPromiseType, setProvidersPromiseType,
} from "../../../types/api/user/home.type.data";
import authApi from "@/api/api/auth";

/**
 * fetchWalletBalance
 *
 * دریافت موجودی کیف پول کاربر.
 *
 * @returns Promise<BalanceData>
 */
export const fetchWalletBalance = async (): Promise<BalanceData> => {
    const res = await api.get<ApiResponse<BalanceData>>("/wallet/api/v1/balance");
    return res.data.data;
};

/**
 * fetchChartData
 *
 * دریافت داده‌های تراکنش‌ها برای نمودار کاربر.
 *
 * @param page شماره صفحه (پیش‌فرض: 1)
 * @param size تعداد داده‌ها در هر صفحه (پیش‌فرض: 10)
 * @returns Promise<any>
 */
export const fetchChartData = async (page = 1, size = 10) => {
    const res = await api.get(
        `/20card/api/user/list-all-transactions?page=${page}&size=${size}`
    );
    return res.data;
};

/**
 * fetchCreditPurchases
 *
 * دریافت لیست خریدهای اعتباری کاربر.
 *
 * @param loanID شناسه وام (پیش‌فرض: 1)
 * @returns Promise<any>
 */
export const fetchCreditPurchases = async (loanID = 1, page = 1) => {
    const res = await api.get(`/loan/api/v1/loans-v2?loanID=${loanID}&page=${page}`);
    return res.data;
};

/**
 * fetchInstallments
 *
 * دریافت اقساط وام کاربر.
 *
 * @param loanID شناسه وام (پیش‌فرض: 0)
 * @returns Promise<any>
 */
export const fetchInstallments = async (loanID = 0) => {
    const res = await api.get(`/loan/api/v1/installments?loanID=${loanID}`);
    return res.data;
};

/**
 * fetchWalletReport
 *
 * دریافت گزارش تراکنش‌های کیف پول کاربر.
 *
 * @param page شماره صفحه (پیش‌فرض: 1)
 * @param size تعداد داده‌ها در هر صفحه (پیش‌فرض: 10)
 * @returns Promise<dataTransaction>
 */
export const fetchWalletReport = async (walletPage = 1,loanPage = 1,size = 10,type = "all"): Promise<dataTransaction> => {
  const res = await api.get<ApiResponse<dataTransaction>>(
    `/20card/api/user/list-user-sso-transactions?wallet_page=${walletPage}&loan_page=${loanPage}&size=${size}&type=${type}`
  );
  return res.data.data;
};
/**
 * fetchGenerateReportLink
 *
 * ایجاد لینک دانلود گزارش اعتبارات کاربر.
 *
 * @returns Promise<any>
 */
export const fetchGenerateReportLink = async (): Promise<any> => {
    const res = await api.get<ApiResponse<any>>("/credit/api/generate-report-link");
    return res.data;
};

/**
 * postTransactions
 *
 * ارسال درخواست POST برای دریافت تراکنش‌ها.
 *
 * @param param0 صفحه و تعداد داده‌ها
 * @returns Promise<any>
 */
export const postTransactions = async ({
                                           page = 1,
                                           size = 10,
                                       }: {
    page?: number;
    size?: number;
}) => {
    const response = await api.get(
        `/20card/api/user/list-all-transactions?page=${page}&size=${size}`
    );
    return response.data;
};

/**
 * postPreTransfer
 *
 * مرحله اول درخواست انتقال وجه.
 *
 * @param data اطلاعات تراکنش
 * @returns Promise<any>
 */
export const postPreTransfer = async (data: any) => {
    const response = await api.post(`/wallet/api/v1/preTransfer`, data);
    return response.data;
};

/**
 * postDetailTransfer
 *
 * ارسال درخواست جزئیات انتقال وجه.
 *
 * @param data اطلاعات تراکنش
 * @returns Promise<any>
 */
export const postDetailTransfer = async (data: any) => {
    const response = await api.post(`/wallet/api/v1/transfer`, data);
    return response.data;
};

/**
 * postOtpTransfer
 *
 * تایید نهایی انتقال وجه با OTP.
 *
 * @param data اطلاعات OTP
 * @returns Promise<any>
 */
export const postOtpTransfer = async (data: any) => {
    const response = await api.post(`/wallet/api/v1/transferConfirm`, data);
    return response.data;
};

/**
 * postOldPassword
 *
 * تغییر رمز عبور قدیمی کاربر.
 *
 * @param data اطلاعات رمز عبور
 * @returns Promise<any>
 */
export const postOldPassword = async (data: any) => {
    const response = await api.post(`/sso/api/v1/changePass`, data);
    return response.data;
};

/**
 * postNewPassword
 *
 * تایید رمز عبور جدید.
 *
 * @param data اطلاعات رمز عبور
 * @returns Promise<any>
 */
export const postNewPassword = async (data: any) => {
    const response = await api.post(`/sso/api/v1/changePassConfirm`, data);
    return response.data;
};

/**
 * fetchUserBankAccounts
 *
 * دریافت لیست حساب‌های بانکی کاربر.
 *
 * @returns Promise<UserBankAccountsDaum[]>
 */
export const fetchUserBankAccounts = async (): Promise<
    UserBankAccountsDaum[]
> => {
    const res = await api.get<ApiResponse<UserBankAccountsDaum[]>>(
        `/20card/api/user/list-user-bank-accounts`
    );
    return res.data.data;
};

/**
 * fetchWithdrawAccounts
 *
 * دریافت لیست حساب‌های برداشت کاربر.
 *
 * @returns Promise<WithdrawData>
 */
export const fetchWithdrawAccounts = async ({page = 1, size = 10}: {
    page?: number | string;
    size?: number | string;
}): Promise<WithdrawData> => {
    const res = await api.get<ApiResponse<WithdrawData>>(
        `/20card/api/user/wallet/withdraw-list?page=${page}&size=${size}`
    );
    return res.data?.data;
};

/**
 * postPreWithdraw
 *
 * ثبت درخواست پیش‌برداشت کیف پول کاربر.
 *
 * @param data اطلاعات برداشت
 * @returns Promise<any>
 */
export const postPreWithdraw = async (data: any) => {
    const response = await api.post(
        `/20card/api/user/wallet/pre-withdraw-request`,
        data
    );
    return response.data;
};

/**
 * postWithdraw
 *
 * ثبت درخواست برداشت کیف پول.
 *
 * @param data اطلاعات برداشت
 * @returns Promise<any>
 */
export const postWithdraw = async (data: any) => {
    const response = await api.post(
        `/20card/api/user/wallet/withdraw-request`,
        data
    );
    return response.data;
};

/**
 * postWithdrawConfirm
 *
 * تایید نهایی درخواست برداشت کیف پول.
 *
 * @param data اطلاعات تایید
 * @returns Promise<any>
 */
export const postWithdrawConfirm = async (data: any) => {
    const response = await api.post(
        `/20card/api/user/wallet/withdraw-request-confirm`,
        data
    );
    return response.data;
};

/**
 * fetchUserLastInquiry
 *
 * دریافت آخرین استعلام اعتباری کاربر.
 *
 * @returns Promise<CreditDataMain>
 */
export const fetchUserLastInquiry = async (): Promise<CreditDataMain> => {
    const res = await api.get<ApiResponse<CreditDataMain>>(
        `/credit/api/user-last-inquiry`
    );
    return res.data?.data;
};

/**
 * fetchUserListBusinesses
 *
 * دریافت لیست کسب‌وکارهای کاربر.
 *
 * @returns Promise<BusinessesDatum[]>
 */
export const fetchUserListBusinesses = async (): Promise<BusinessesDatum[]> => {
    const res = await api.get<ApiResponse<BusinessesDatum[]>>(
        `/credit/api/list-businesses`
    );
    return res.data?.data;
};

/**
 * fetchPayment
 *
 * دریافت لیست تراکنش‌های پرداخت کاربر.
 *
 * @returns Promise<PaymentData>
 */
export const fetchPayment = async ({page, size}: {
    page?: number | string;
    size?: number | string
}): Promise<PaymentData> => {
    const res = await api.get<ApiResponse<PaymentData>>(
        `/20card/api/user/payment/list?page=1&size=10`
    );
    return res.data?.data;
};

/**
 * fetchListTicketUser
 *
 * دریافت لیست بلیط‌های کاربر.
 *
 * @returns Promise<ListTicketUserData>
 */
export const fetchListTicketUser = async (): Promise<ListTicketUserData> => {
    const res = await api.get<ApiResponse<ListTicketUserData>>(
        `/20card/api/user/list-ticket-user`
    );
    return res.data?.data;
};

/**
 * fetchResetRequest
 *
 * دریافت لیست درخواست‌های بازنشانی اعتبار.
 *
 * @returns Promise<any[]>
 */
export const fetchResetRequest = async (): Promise<any[]> => {
    const res = await api.get<ApiResponse<any[]>>(`/credit/api/reset-request`);
    return res.data?.data;
};

/**
 * fetchMapgishe
 *
 * دریافت داده‌های Mapgishe کاربر.
 *
 * @returns Promise<MapgisheDaum[]>
 */
export const fetchMapgishe = async (): Promise<MapgisheDaum[]> => {
    const res = await api.post<ApiResponse<MapgisheDaum[]>>(
        `/20card/api/user/mapgishe`
    );
    return res.data?.data;
};

/**
 * postPaymentCharge
 *
 * ثبت تراکنش پرداخت با کارت کاربر.
 *
 * @param data اطلاعات پرداخت
 * @returns Promise<any>
 */
export const postPaymentCharge = async (data: any) => {
    const response = await api.post(`/20card/api/user/payment/charge`, data);
    return response.data;
};

/**
 * postPaymentWallet
 *
 * شارژ کیف پول کاربر.
 *
 * @returns Promise<any>
 */
export const postPaymentWallet = async () => {
    const response = await api.post(`/credit/api/payment/wallet`);
    return response.data;
};

/**
 * postRequestIranCredit
 *
 * درخواست اعتبار ایران.
 *
 * @param data اطلاعات درخواست
 * @returns Promise<any>
 */
export const postRequestIranCredit = async (data: any) => {
    const response = await api.post(`/credit/api/request-iran-credit`, data);
    return response.data;
};

/**
 * postRequestSendTicketUser
 *
 * ارسال بلیط به کاربر.
 *
 * @param data اطلاعات بلیط
 * @returns Promise<any>
 */
export const postRequestSendTicketUser = async (data: any) => {
    const response = await api.post(`/20card/api/user/send-ticket-user`, data);
    return response.data;
};

/**
 * postRequestSendBank
 *
 * ارسال اطلاعات پرداخت به بانک.
 *
 * @param data اطلاعات بانک
 * @returns Promise<any>
 */
export const postRequestSendBank = async (data: any) => {
    const response = await api.post(`/credit/api/payment/bank`, data);
    return response.data;
};

/**
 * postRequestConfirmOtp
 *
 * تایید OTP اعتبار ایران.
 *
 * @param data اطلاعات OTP
 * @returns Promise<any>
 */
export const postRequestConfirmOtp = async (data: any) => {
    const response = await api.post(`/credit/api/confirm-otp-iran-credit`, data);
    return response.data;
};

/**
 * postRequestRegister
 *
 * ثبت نام کاربر SSO.
 *
 * @param data اطلاعات کاربر
 * @returns Promise<any>
 */
export const postRequestRegister = async (data: any) => {
    // const response = await api.post(`/20card/api/user-sso/register`, data);
    const response = await api.post(`/20card/api/user-sso/register`, data);
    return response.data;
};

/**
 * postRequestOtpRegister
 *
 * تایید ثبت نام کاربر SSO با OTP.
 *
 * @param data اطلاعات OTP
 * @returns Promise<any>
 */
export const postRequestOtpRegister = async (data: any) => {
    const response = await api.post(
        `/20card/api/user-sso/register-confirm`,
        data
    );
    return response.data;
};

/**
 * postRequestResetPass
 *
 * درخواست بازنشانی رمز عبور.
 *
 * @param data اطلاعات کاربر
 * @returns Promise<any>
 */
export const postRequestResetPass = async (data: any) => {
    const response = await api.post(`/sso/api/v1/resetPass`, data);
    return response.data;
};

/**
 * postRequestLogin
 *
 * ورود کاربر با SSO.
 *
 * @param data اطلاعات ورود
 * @returns Promise<any>
 */
export const postRequestLogin = async (data: any) => {
    const response = await authApi.post(`/sso/api/v1/login`, data);
    return response.data;
};

/**
 * postRequestResetPassConfirm
 *
 * تایید بازنشانی رمز عبور.
 *
 * @param data اطلاعات تایید
 * @returns Promise<any>
 */
export const postRequestResetPassConfirm = async (data: any) => {
    const response = await api.post(`/sso/api/v1/resetPassConfirm`, data);
    return response.data;
};

/**
 * postRequestCreditOrder
 *
 * ثبت سفارش اعتبار.
 *
 * @param data اطلاعات سفارش
 * @returns Promise<any>
 */
export const postRequestCreditOrder = async (data: any) => {
    const response = await api.post(`/credit/api/credit-order`, data);
    return response.data;
};

/**
 * postRequestLinkDownload
 *
 * دریافت لینک دانلود گزارش.
 *
 * @param body اطلاعات درخواست
 * @returns Promise<Blob>
 */
export const postRequestLinkDownload = async (body: any) => {
    const response = await api.post(`/credit/api/link-download`, body, {
        responseType: "blob",
    });
    return response;
};

/**
 * postRequestEditLastInquiryUser
 *
 * ویرایش آخرین استعلام کاربر.
 *
 * @param data اطلاعات ویرایش
 * @returns Promise<any>
 */
export const postRequestEditLastInquiryUser = async (data: any) => {
    const response = await api.post(`/credit/api/edit-last-inquiry-user`, data);
    return response.data;
};

/**
 * postRequestCreateUserBankAccount
 *
 * ایجاد حساب بانکی جدید برای کاربر.
 *
 * @param data اطلاعات حساب
 * @returns Promise<any>
 */
export const postRequestCreateUserBankAccount = async (data: any) => {
    const response = await api.post(
        `/20card/api/user/create-user-bank-account`,
        data
    );
    return response.data;
};

/**
 * postRequestsendCreditData
 *
 * ارسال داده‌های اعتبار به سیستم.
 *
 * @param data اطلاعات اعتبار
 * @returns Promise<any>
 */
export const postRequestsendCreditData = async (data: any) => {
    const response = await api.post(`/credit/api/send-credit-data`, data);
    return response.data;
};

/**
 * postRequestEditCheck
 *
 * ویرایش پاسخ چک ادمین.
 *
 * @param data اطلاعات ویرایش
 * @returns Promise<any>
 */
export const postRequestEditCheck = async (data: any) => {
    const response = await api.put(`/credit/api/edit-answer-admin-check`, data);
    return response.data;
};


export const insBalancePay = async (data: any) => {
    const response = await api.post(
        `/loan/api/v1/insBalancePay`,
        data
    );
    return response.data;
};

export const paymentRequest = async (data: any) => {
    const response = await api.post(
        `/20card/api/user/payment/request`,
        data
    );
    return response.data;
};

export const fetchListUserMessage = async (page = 1, per_page = 10) => {
    const res = await api.get(`20card/api/user/list-user-message?page=${page}&per_page=${per_page}`);
    return res.data;
};

export const fetchShowUserMessage = async (id: number) => {
    const res = await api.get(`20card/api/user/show-user-message/${id}`);
    return res.data;
};

export const fetchCountUserMessage = async () => {
    const res = await api.get(`20card/api/user/count-user-message`);
    return res.data;
};


export const fetchGuarantorType = async (data: any) => {
    const response = await api.post(`/credit/api/guarantor-type`, data);
    return response.data;
};

export const fetchSelector = async () => {
    const res = await api.get(`/credit/api/selector-financial`);
    return res.data;
};

export const postRequestGetOtp = async (data: any) => {
    const response = await api.post(`/credit/api/get-financial-otp`, data);
    return response.data;
};

export const resendFinancialOtp = async () => {
    const response = await api.get(`/credit/api/resend-financial-otp`);
    return response.data;
};

export const fetchGetFile = async (): Promise<any> => {
    const res = await api.get<ApiResponse<any>>("/credit/api/get-financial-file");
    return res.data;
};

export const fetchDownloadFile = async (): Promise<any> => {
    const res = await api.get<ApiResponse<any>>("/credit/api/download-financial-file", {
        responseType: 'blob',
    });
    return res.data;
};

export const fetchJudicialSelector = async () => {
    const res = await api.get('credit/api/selector-judicial');
    return res.data;
};

export const postJudicialGetOtp = async (data: { otp: string }) => {
    const res = await api.post('credit/api/get-judicial-otp', data);
    return res.data;
};

export const resendJudicialOtp = async () => {
    const res = await api.get('credit/api/get-judicial-resend-otp');
    return res.data;
};

export const getJudicialReport = async () => {
    const res = await api.get('credit/api/get-judicial-report');
    return res.data;
};

export const getProviders = async (): Promise<getProvidersPromiseType> => {
    const res = await api.get('credit/api/providers/get-providers');
    return res.data;
};
export const setProviders = async (data:setProvidersPayloadType):Promise<setProvidersPromiseType> => {
    const res = await api.post('credit/api/providers/set-provider',data);
    return res.data;
};